class TruncatedTextBlock extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.truncated-text-block__content');
    this.toggle = this.querySelector('.truncated-text-block__toggle');

    if (!this.content || !this.toggle) return;

    this.init();
  }

  init() {
    // Check if content needs truncation
    this.checkOverflow();

    // Toggle click handler
    this.toggle.addEventListener('click', this.handleToggle.bind(this));

    // Recheck on resize
    this.resizeObserver = new ResizeObserver(() => {
      if (!this.content.classList.contains('is-expanded')) {
        this.checkOverflow();
      }
    });
    this.resizeObserver.observe(this);
  }

  checkOverflow() {
    // Temporarily remove clamping to measure full height
    const wasClamped = this.content.classList.contains('is-clamped');
    this.content.classList.remove('is-clamped');

    const fullHeight = this.content.scrollHeight;

    // Get the clamped height based on lines
    const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
    const lines = parseInt(this.dataset.lines) || 3;
    const clampedHeight = lineHeight * lines;

    // Restore clamping
    if (wasClamped || fullHeight > clampedHeight + 5) {
      this.content.classList.add('is-clamped');
    }

    // Show/hide toggle based on whether content overflows
    if (fullHeight > clampedHeight + 5) {
      this.toggle.classList.add('is-visible');
    } else {
      this.toggle.classList.remove('is-visible');
    }
  }

  handleToggle() {
    const isExpanded = this.content.classList.contains('is-expanded');

    if (isExpanded) {
      this.content.classList.remove('is-expanded');
      this.content.classList.add('is-clamped');
    } else {
      this.content.classList.add('is-expanded');
      this.content.classList.remove('is-clamped');
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('truncated-text-block', TruncatedTextBlock);
